export const FETCHED_USERS = 'FETCHED_USERS_CHUNKS';
export const FETCH_USER = 'FETCH_USER';
export const FETCHED_USER_ROLES = 'FETCHED_USER_ROLES';
export const FETCHED_USER_SITES = 'FETCHED_USER_SITES';
export const FETCHED_USER_LANGUAGES = 'FETCHED_USER_LANGUAGES';
export const ADD_ROLE_TO_USER = 'ADD_ROLE_TO_USER';
export const UPDATED_USER_ROLES = 'UPDATED_USER_ROLES';
export const ADD_SITE_TO_USER = 'ADD_SITE_TO_USER';
export const ADD_LANGUAGE_TO_USER = 'ADD_LANGUAGE_TO_USER';
export const CHANGE_USER_ROLES = 'CHANGE_USER_ROLES';
export const FETCHED_PERMISSIONS_GROUPED = 'FETCHED_PERMISSIONS_GROUPED';
export const FETCHED_USER_PERMISSIONS = 'FETCHED_USER_PERMISSIONS';


// WEBPACK FOOTER //
// ./src/containers/users/types.js